export function getAudienceValuesFromObject(args) {
  const gendersValue = args?.audienceGenders?.value || []
  const agesValueRaw = Array.isArray(args?.audienceAges)
    ? args?.audienceAges.map(item => item.value)
    : [args?.audienceAges?.value]
  const agesValue = agesValueRaw.filter(item => item) || []
  const countriesValue = args?.audienceCountries?.value || []

  const audienceVars = {
    genders: gendersValue,
    ages: agesValue,
    countries: countriesValue,
  }

  return audienceVars
}
